import "./Error.css";

import logo from "../../../assests/bunnyMoni.jpg";
import { useLocation } from "react-router-dom";

const Error: React.FC = () => {
  const location = useLocation();
  const errorMessage = location.state?.message || "page not found.";

  return (
    <div className="container">
      <div className="card">
        <img className="logo" src={logo} alt="hobsavings logo" />
        <h1 className="title">oops!</h1>
        <p className="label">{errorMessage}</p>
      </div>
    </div>
  );
};

export default Error;
